
import Vue from 'vue'
import element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {addClass, removeClass} from "element-ui/src/utils/dom";

element.Dialog.props.closeOnClickModal.default = false
// window.Element = element;

// element.Table.created=function() {
//     this.tableId = 'el-table_' + tableIdSeed++;
//     this.debouncedUpdateLayout = function () { this.doLayout()};
// }

element.Table.components.TableHeader.methods.handleMouseDown=function(event, column){

    if (this.$isServer) return;
    if (column.children && column.children.length > 0) return;
    /* istanbul ignore if */
    if (this.draggingColumn && this.border) {
        this.dragging = true;

        this.$parent.resizeProxyVisible = true;

        const table = this.$parent;
        const tableEl = table.$el;
        const tableLeft = tableEl.getBoundingClientRect().left;
        const columnEl = this.$el.querySelector(`th.${column.id}`);
        const columnRect = columnEl.getBoundingClientRect();
        const minLeft = columnRect.left - tableLeft + 30;

        addClass(columnEl, 'noclick');

        this.dragState = {
            startMouseLeft: event.clientX,
            startLeft: columnRect.right - tableLeft,
            startColumnLeft: columnRect.left - tableLeft,
            tableLeft
        };

        const resizeProxy = table.$refs.resizeProxy;
        resizeProxy.style.left = this.dragState.startLeft + 'px';

        document.onselectstart = function() { return false; };
        document.ondragstart = function() { return false; };

        const handleMouseMove = (event) => {
            const deltaLeft = event.clientX - this.dragState.startMouseLeft;
            const proxyLeft = this.dragState.startLeft + deltaLeft;

            resizeProxy.style.left = Math.max(minLeft, proxyLeft) + 'px';

            if (this.dragging) {
                const {
                    startColumnLeft,
                    startLeft
                } = this.dragState;
                const finalLeft = parseInt(resizeProxy.style.left, 10);
                const columnWidth = finalLeft - startColumnLeft;
                column.width = column.realWidth = columnWidth;
                table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);
                this.$parent.doLayout();
                // this.store.scheduleLayout();
            }
        };

        const handleMouseUp = () => {
            if (this.dragging) {
                const {
                    startColumnLeft,
                    startLeft
                } = this.dragState;
                const finalLeft = parseInt(resizeProxy.style.left, 10);
                const columnWidth = finalLeft - startColumnLeft;
                column.width = column.realWidth = columnWidth;
                table.$emit('header-dragend', column.width, startLeft - startColumnLeft, column, event);

                this.store.scheduleLayout();

                document.body.style.cursor = '';
                this.dragging = false;
                this.draggingColumn = null;
                this.dragState = {};

                table.resizeProxyVisible = false;
            }

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.onselectstart = null;
            document.ondragstart = null;

            setTimeout(function() {
                removeClass(columnEl, 'noclick');
            }, 0);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }

};



Vue.use(element, { size: 'small' })
